interface CourseHeroProps {
  badge?: string;
  title?: string;
  subtitle?: string;
  tagline?: string;
  description?: string;
  hours?: string;
  bgSeq?: string;
}

export default function CourseHero({
  badge = "Vagas Limitadas",
  title = "Método C.A.T",
  subtitle = "Vendedora",
  tagline = "Cliente · Atenção · Todo tempo",
  description = "Vendas, varejo, WhatsApp Business e IA aplicados para você faturar mais já nos primeiros dias. Aprenda com Gleice Lyra, referência nacional em varejo.",
  hours = "+30 horas de conteúdo",
  bgSeq = "coursehero1",
}: CourseHeroProps) {
  return (
    <section className="relative w-full min-h-[520px] bg-[#111] overflow-hidden flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=modern%20minimalist%20sales%20training%20seminar%20room%20with%20warm%20golden%20spotlights%20on%20a%20stage%2C%20dark%20background%20with%20subtle%20bokeh%2C%20premium%20business%20conference%20ambiance%2C%20elegant%20professional%20environment%2C%20sophisticated%20and%20dramatic%20lighting%20contrast&width=1440&height=520&seq=${bgSeq}&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/30" />
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg,transparent,transparent 79px,rgba(255,255,255,0.1) 80px),repeating-linear-gradient(90deg,transparent,transparent 79px,rgba(255,255,255,0.1) 80px)",
        }}
      />
      <div className="relative z-10 w-full px-6 md:px-24 py-20">
        <div className="max-w-3xl">
          <span className="inline-block text-[#b8962e] text-xs tracking-[0.3em] uppercase font-medium mb-4 border border-[#b8962e]/40 px-3 py-1">
            {badge}
          </span>
          <h1 className="text-white text-4xl md:text-5xl font-light leading-tight tracking-tight mb-3">
            {title}
          </h1>
          <p className="text-[#b8962e] text-sm tracking-[0.2em] uppercase font-medium mb-6">
            {tagline}
          </p>
          <p className="text-white/70 text-base md:text-lg font-light leading-relaxed mb-8 max-w-xl">
            {description}
          </p>
          <div className="flex flex-wrap items-center gap-6">
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-time-line text-[#b8962e]"></i>
              </span>
              <span>{hours}</span>
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-computer-line text-[#b8962e]"></i>
              </span>
              <span>100% Online</span>
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-award-line text-[#b8962e]"></i>
              </span>
              <span>Certificado</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
